import { render, staticRenderFns } from "./NewPersonPhoneNumber.vue?vue&type=template&id=5591a934&scoped=true&"
import script from "./NewPersonPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./NewPersonPhoneNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5591a934",
  null
  
)

export default component.exports